import * as React from 'react';

import { uniq } from 'lodash';

import { CartSeat } from '../../../classes/seat';
import { tryCheckout, closeCartRemovalModal } from '../../../cart/actions/cart-actions';
import { Dispatch } from 'redux';
import { getCurrencyFormat } from '../../../helpers/currency-format';
import { Seat } from '../../../classes/seat';
import CartItems from './cart-items';
import { getCurrentLanguage } from '../../../helpers/window-helpers';
import { IAltText } from '../../../classes/alt-text';
import { ItemType } from '../../../classes/item-type';
import { SeatingOptionGroup } from '../../../classes/seating-option';
import { PriceType } from '../../../classes/price-type';
import * as isEqual from 'react-fast-compare';

export interface ICartProps {
    cartSeats: Array<CartSeat>;
    dispatch: any /*Dispatch<any>*/;
    itemId: number;
    itemType: ItemType;
    allowExchangesAddon: boolean;
    altText: IAltText;

    selectedAdditionalOptionGroups: Array<SeatingOptionGroup>; //used for non-seat bound seating options

    cartCheckoutButton: string;
    cartAddMoreButton: string;
    seatMapId: string;
    selectedSeatIds: string;
    allSeats: Array<Seat>;
    cartDisabled: boolean;
    cartMessage: string;

    //CartItems props
    cartSubtotalLabel: string;
    cartEmptyNotice: string;
    useZoneDescription: boolean;
    groupSeatCartItemText: string;
    currencyFormat: string;
    exchangeFreeLabel: string;
    brandId: string;
    additionalNotes: string;

    selectedPriceTypes: Array<PriceType>;

}

interface ICartInteractionState {
    mobileCartOpen: boolean;
}

class Cart extends React.Component<ICartProps, ICartInteractionState>{
    constructor(props) {
        super(props);
        this.state = {
            mobileCartOpen: false,
        }
    }

    shouldComponentUpdate(nextProps: ICartProps, nextState) {
        return this.props.cartSeats.length != nextProps.cartSeats.length
            || this.props.cartDisabled != nextProps.cartDisabled
            || this.props.selectedAdditionalOptionGroups.length != nextProps.selectedAdditionalOptionGroups.length
            || this.props.selectedPriceTypes.length != nextProps.selectedPriceTypes.length
            || this.props.selectedSeatIds != nextProps.selectedSeatIds
            || this.props.additionalNotes != nextProps.additionalNotes
            || isEqual(this.props.cartSeats.map(s => s.selectedPricing.priceTypeId), nextProps.cartSeats.map(s => s.selectedPricing.priceTypeId));
    }

    render() {
        var cartContainerClass = 'cart-container';

        return (
            <div className={cartContainerClass} >
                    <div className="cart-mini-container">

                        <CartItems {...this.props} />

                    </div>
            </div>
        );
    }

    _onCheckoutClick() {
        this.props.dispatch(tryCheckout(this.props.cartSeats, this.props.selectedAdditionalOptionGroups, this.props.additionalNotes, this.props.itemId, false));
    }

    _onAddMoreCheckoutClick() {
        this.props.dispatch(tryCheckout(this.props.cartSeats, this.props.selectedAdditionalOptionGroups, this.props.additionalNotes, this.props.itemId, true));
    }

    _expandMobileCart() {
        this.setState({ mobileCartOpen: !this.state.mobileCartOpen });
    }


}

export default Cart;